import camelize from 'camelcase-keys-deep';

export default class LinkedAdjudication {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  current() {
    return this.env().Adjudication.getById(this.currentId);
  }
}
